export default __webpack_public_path__ + "static/summer_containers64-d655bfe6449544159448c737918e3b7d.webp";